import styled from '@emotion/styled';

import { ButtonGeneral, DEFAULT_COLORS, DialogV2, Text } from '@myrealtrip/web-ui';

import { useDetermineMobile } from '@myrealtrip/device-detect';
import useRailEuropeNavigation from '~hooks/pointToPointTicket/useRailEuropeNavigation';

interface Props {
  description: string;
  title?: string;
  buttonText?: string;
  onClose: () => void;
}

const RailEuropeErrorDialog = ({ description, title, buttonText = '확인', onClose }: Props) => {
  const isMobile = useDetermineMobile();

  const { navigateToSearch } = useRailEuropeNavigation();

  const handleClickResearch = () => {
    navigateToSearch({ isSingleTrip: true });
    onClose();
  };

  return (
    <DialogV2
      isOpen
      bodyProps={{
        width: isMobile ? '350px' : '400px',
        height: '228px',
      }}
      headerProps={{
        hideClose: true,
        children: title ? (
          <Text typography="headlineBold18" color={DEFAULT_COLORS.gray.s1000}>
            {title}
          </Text>
        ) : null,
      }}
      footerProps={{
        children: (
          <ButtonGeneral
            priority="primaryOpt"
            shape="rectangle"
            size="small"
            onClick={handleClickResearch}
          >
            <Text typography="headlineNormal14" color={DEFAULT_COLORS.white}>
              {buttonText}
            </Text>
          </ButtonGeneral>
        ),
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '12px 24px',
        },
      }}
    >
      <Content>
        <Text typography="paragraphNormal16" color={DEFAULT_COLORS.gray.s1000}>
          {description}
        </Text>
      </Content>
    </DialogV2>
  );
};

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  word-break: keep-all;
`;

export default RailEuropeErrorDialog;
